import { RouteObject } from 'react-router-dom';
import AdminPage from 'src/pages/admin';
import App from 'src/pages/app';
import UserAuthorizationPage from 'src/pages/user-authorization';

export const routeName = {
	userAuthorization: 'user-authorization',
	admin: 'admin-extension'
};

export const publicRoutes: RouteObject[] = [
	{
		path: '/',
		element: (
			<App />
		),
		children: [
			{
				path: routeName.userAuthorization,
				element: <UserAuthorizationPage />
			},
			{
				path: routeName.admin,
				element: <AdminPage />
			}
		]
	}
];